export default __webpack_public_path__ + "d69292370b2647c8e9960846721a2e77.png";